module.exports = __webpack_public_path__ + "img/express.ff35e25a.svg";